// @flow
import React from 'react'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import renderHTML from 'react-render-html'
import './styles.scss'

const isMobile = browserCheck.isMobile

export class Person extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      imageSrc: null
    }
  }

  setImageSource() {
    let imgSrc = null
    try {
      const trySrc = require('../../images/' + this.props.image + '.jpg')
      imgSrc = trySrc
    } catch (err) {
      console.log(
        '⚠ IMAGE NOT FOUND:',
        '../../images/' + this.props.image + '.jpg'
      )
      if (this.props.format !== 'wide') {
        imgSrc = require('../../images/_dummy.jpg')
      }
    }
    return imgSrc
  }

  componentDidMount() {
    this.setState({
      imageSrc: this.setImageSource()
    })
  }

  render() {
    return (
      <div id={'person-' + this.props.index} className='person column'>
        {this.props.format !== 'none' && (
          <div
            className={
              this.props.format === 'wide'
                ? 'image-wrapper ui fluid image'
                : 'image-wrapper ui medium circular image'
            }
          >
            <div className='image-inner'>
              <img
                src={this.state.imageSrc}
                style={{
                  transform: `scale(${this.props.scale}) translateY(${this.props.translateY}%)`
                }}
              />
            </div>
          </div>
        )}
        <div
          className={this.props.format === 'wide' ? 'wide details' : 'details'}
        >
          <div className='names'>{this.props.name}</div>
          <div className='time'>{this.props.function}</div>
          <div className='text'>{renderHTML(this.props.text)}</div>
        </div>
      </div>
    )
  }
}
